import { render, staticRenderFns } from "./fastCategory.vue?vue&type=template&id=665499b9"
import script from "./fastCategory.vue?vue&type=script&lang=js"
export * from "./fastCategory.vue?vue&type=script&lang=js"
import style0 from "./fastCategory.vue?vue&type=style&index=0&id=665499b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports